import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'
import { rgba } from 'polished'

import { media } from '../../../styles/utils'
import { container, innerContainer, padding, gutterWidth, hoverState } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { heading, paragraph } from '../../../styles/type';

class BlockSectionOpening extends React.Component {

	state = {
	
	}
	
	render() {
		const { title, paragraph } = this.props;
        
		return (
			<Wrapper>
				<Heading
					dangerouslySetInnerHTML={{__html: title}}
				/>
				<Text
					dangerouslySetInnerHTML={{__html: paragraph}}
				/>
			</Wrapper>
		)
	}
}

// text styles
const Heading = styled.div`
	${heading}
`

const Text = styled.div`
	p {
		${paragraph};
	}
`


const Wrapper = styled.div`
	${innerContainer};
	display: flex;
	align-items: baseline;

	${media.tablet`
		flex-direction: column;
		align-items: center;
	`} 

	${Heading}, ${Text} {
		flex: 50%;
		box-sizing: border-box;

		${media.tablet`
			flex: none;
			width: 360px;
			max-width: 100%;
		`}
	}

	${Heading} {
		/* half gutter size */
		padding-right: 2.5rem;

		${media.tablet`
			margin-bottom: 3rem;
			padding-right: 0;
		`}
	}

	${Text} {
		/* half gutter size */
		padding-left: 2.5rem;

		${media.tablet`
			padding-left: 0;
		`}
	}
`

// layout
BlockSectionOpening.wrapper = css`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export default BlockSectionOpening



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockSectionOpening.js